<script lang="ts">
  import { store } from '$lib/store.svelte';
  import { genDeviceId, hashPassword } from '$lib/crypto';

  interface Props { onMessage?: (msg: string, type?: 'success' | 'warning') => void }
  let { onMessage }: Props = $props();

  let workerUrl = $state(store.syncConfig?.workerUrl ?? '');
  let code = $state(store.syncConfig?.code ?? '');
  let password = $state('');
  let busy = $state(false);

  async function saveConfig() {
    if (!workerUrl.trim() || !code.trim() || !password) {
      onMessage?.('Completá los 3 campos', 'warning');
      return;
    }
    const deviceId = store.syncConfig?.deviceId || genDeviceId();
    await store.saveSyncConfig({
      workerUrl: workerUrl.trim().replace(/\/$/, ''),
      code: code.trim(),
      passwordHash: await hashPassword(password, deviceId),
      deviceId
    });
    await unlock();
  }

  async function unlock() {
    busy = true;
    const ok = await store.unlock(password);
    busy = false;
    onMessage?.(ok ? 'Desbloqueado: sincroniza solo cada 30 s' : store.lastSyncMessage || 'Password incorrecta', ok ? 'success' : 'warning');
  }

  async function migrate() {
    if (!password) return onMessage?.('Ingresá la password para migrar', 'warning');
    if (!confirm('Re-cifra TODOS los registros con el esquema v2 y los sube. Antes, sincronizá los otros dispositivos para no pisar cambios sin subir. ¿Seguir?')) return;
    busy = true;
    try {
      await store.migrate(password);
      onMessage?.(store.lastSyncMessage);
    } catch (e) {
      onMessage?.(e instanceof Error ? e.message : String(e), 'warning');
    } finally {
      busy = false;
    }
  }
</script>

<div class="view-title">Sincronización</div>
<p class="view-sub">Todo se cifra en este dispositivo. Cloudflare nunca ve el contenido.</p>

<div class="item" style="display:block;margin-bottom:var(--space-lg)">
  <strong>Estado:</strong> {store.syncStatus}{store.lastSyncMessage ? ` — ${store.lastSyncMessage}` : ''}
  {#if store.legacyPending > 0}
    <p style="margin-top:var(--space-xs)">Hay {store.legacyPending} registros con cifrado viejo. Ingresá la password y migrá a v2.</p>
  {/if}
</div>

<div class="form-group">
  <label class="form-label" for="sync-url">Worker URL</label>
  <input id="sync-url" type="url" class="form-input" bind:value={workerUrl} />
</div>
<div class="form-group">
  <label class="form-label" for="sync-code">Código de sync</label>
  <input id="sync-code" type="text" class="form-input" bind:value={code} />
</div>
<div class="form-group">
  <label class="form-label" for="sync-pass">Password</label>
  <input id="sync-pass" type="password" class="form-input" bind:value={password} autocomplete="current-password" />
</div>

<div style="display:flex;gap:var(--space-sm);flex-wrap:wrap">
  {#if !store.syncConfig?.code}
    <button type="button" class="btn btn-primary" disabled={busy} onclick={saveConfig}>Guardar y desbloquear</button>
  {:else if !store.unlocked}
    <button type="button" class="btn btn-primary" disabled={busy} onclick={unlock}>Desbloquear</button>
  {:else}
    <button type="button" class="btn btn-primary" disabled={busy} onclick={() => store.runSync(password || undefined)}>Sincronizar ahora</button>
    <button type="button" class="btn btn-secondary" disabled={busy} onclick={migrate}>Migrar a cifrado v2</button>
    <button type="button" class="btn btn-danger" disabled={busy} onclick={() => store.lock()}>Bloquear este dispositivo</button>
  {/if}
</div>
